export function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export function groupArrayByKey(
  array: Array<any>,
  groupKey: string,
  preGroupedArray?: object
) {
  let arrayGrouped = preGroupedArray || {};
  array.forEach((item) => {
    let key = item[groupKey];
    arrayGrouped[key] = arrayGrouped[key] || [];
    arrayGrouped[key].push(item);
  });
  return arrayGrouped;
}
